<script lang="ts" setup>

import { defineComponent, watchEffect, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import stateStore from "./utils/store";
import { useUserStore } from "@/stores/userStore";
import storeCliente from "./utils/storeCliente";
import { getToken } from "./utils/funcoes";
import * as service from "./services/usuariosService";

import MainHeader from "./components/Layouts/MainHeader.vue";
import MainSidebar from "./components/Layouts/MainSidebar.vue";
import MainFooter from "./components/Layouts/MainFooter.vue";

import LoginCliente from "./cliente/Login.vue";

const userStore = useUserStore();
const stateStoreInstance = stateStore;
const route = useRoute();

var controle = reactive({
  rota: "",
})

onMounted(() => {
  console.log("montando 2...");
  document.body.classList.add("bg-body-secondary");

  userStore.setToken(service.getToken());

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);
    userStore.setUser(user);
  }

  controle.rota = String(route.name || "");

  setInterval(() => {
    //verificaEstaLogado();
  }, 60000); // Verifica a cada 60 segundos

})

watchEffect(async () => {
  if (stateStoreInstance.open) {
    document.body.classList.remove("sidebar-show");
    document.body.classList.add("sidebar-hide");
  } else {
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
  }
})

function getTokenCliente() {
  const x = localStorage.getItem("clienteToken");

  if (x != null) {
    return x;
  }
  return "";
}

async function verificaEstaLogado() {

  try {
      var logado = await service.estaLogado();
      if (logado == true) {
        console.log("Usuário está logado.");
      } else {
        var sair = await service.logout();
        console.log("Logout realizado com sucesso.");
        window.location.reload();
      }
  } catch (error) {
    console.error("Erro ao obter o token:", error);
    return;
  }


}

</script>

<template>

  <div class="container-fluid" v-if="controle.rota == '/cliente'">
    <LoginCliente />
    <!-- <router-view v-else/> -->
  </div>

  <div v-else class="">
    <template v-if="userStore.token != ''">
      <MainHeader  />
      <MainSidebar  />
      <div :class="'main-content d-flex flex-column transition overflow-hidden'">
        <router-view />
        <MainFooter/>
      </div>
    </template>
    <template v-else>
       <router-view />
    </template>
  </div>

</template>
